import { render, staticRenderFns } from "./MyPlugins.vue?vue&type=template&id=c7b94172&scoped=true&"
import script from "./MyPlugins.vue?vue&type=script&lang=js&"
export * from "./MyPlugins.vue?vue&type=script&lang=js&"
import style0 from "./MyPlugins.vue?vue&type=style&index=0&id=c7b94172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b94172",
  null
  
)

export default component.exports